<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zhH6iG/tc-custom/9781452113661.jpg?1705348420841" alt="This image is the cover for the book Ice Cream Treats"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ice Cream Treats
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Turn your favorite carton of ice cream into a real treat with over fifty recipes for super-cool desserts—from cakes &amp; pies to sundaes &amp; sandwiches.</b></p><p> What’s cooler than ice cream? How about over fifty chill-out ways to transform store-bought ice cream into truly spectacular desserts? </p><p> With <i>Ice Cream Treats</i>, you’re only a pint away from turning your favorite flavor into delicious cakes, pies, sundaes, shakes, and sandwiches. Nothing says summertime like a frothy Berry-Vanilla Milk Shake or a Peach Crisp Parfait. But you can indulge anytime of the year with decadent desserts like Black Forest Ice Cream Cake or creamy Butter Pecan Pie. Even the holidays are more festive with unexpected treats like Pumpkin Sandwiches with Gingersnaps or Eggnog Ice Cream Torte with Rum Whipped Cream. And once you try treats like Pistachio Sandwiches with Walnut Brownies, you’ll never settle for a cone again. </p> If you want to try your hand at making your own ice cream, there are even recipes for the classics like Dark Chocolate, Coffee Bean, Vanilla Bean, and Strawberry. To top it all off, you’ll find an ice cream buyer’s guide, along with tips and tools for making perfect ice cream treats. Isn’t it time you treated yourself? 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charity Ferreira, Leigh Beisch
      </h2>
      
      <p class="authorDescription body article">Charity Ferreira is a staff food writer and recipe developer at <I>Sunset Magazine</I>. Her work ahs also appeared in <I>Gourmet, <I>Bon Appetit</I>, and the <I>Los Angeles Times</I>. A graduate of the California Culinary Academy and former pastry chef, she lives in Oakland, California.<br/><br/>Leigh Beisch is a San Francisco-based photographer. Her work has appeared in many magazines, as well as in <I>Olives, Anchovies, and Capers</I> and <I>Cooking for the Week</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c42b46a